import { z } from "zod";

export const sourceLocationSchema = z
  .object({
    fileName: z.string(),
    lineNumber: z.number(),
    columnNumber: z.number().optional(),
    componentName: z.string().optional(),
  })
  .describe("SourceLocation");

export const semanticPreviewElementSchema = z
  .object({
    elementType: z.string(),
    selector: z.string(),
    text: z.string().optional(),
    cssClasses: z.string(),
    outerHtml: z.string(),
    tagName: z.string(),
    openingTag: z.string().optional(),
    hasChildren: z.boolean().optional(),
  })
  .describe("SemanticPreviewElement");

export const semanticFileEditElementSchema = z
  .object({
    elementType: z.string(),
    selector: z.string(),
    text: z.string().optional(),
    cssClasses: z.string(),
    sourceLocation: sourceLocationSchema.optional(),
    name: z.string().optional(),
    path: z.string().optional(),
    tagName: z.string().optional(),
    outerHtml: z.string().optional(),
    nearbyText: z.string().optional(),
    nearbyElements: z.string().optional(),
  })
  .describe("SemanticFileEditElement");

export const computedElementStylesSchema = z
  .object({
    // Text styles
    fontFamily: z.string(),
    fontSize: z.string(),
    fontWeight: z.string(),
    fontStyle: z.string(),
    lineHeight: z.string(),
    letterSpacing: z.string(),
    textAlign: z.string(),
    color: z.string(),
    textTransform: z.string(),
    textDecoration: z.string(),
    whiteSpace: z.string(),
    wordSpacing: z.string(),
    // Layout styles
    backgroundColor: z.string(),
    paddingTop: z.string(),
    paddingRight: z.string(),
    paddingBottom: z.string(),
    paddingLeft: z.string(),
    marginTop: z.string(),
    marginRight: z.string(),
    marginBottom: z.string(),
    marginLeft: z.string(),
    gap: z.string(),
    // Border styles
    borderTopWidth: z.string(),
    borderRightWidth: z.string(),
    borderBottomWidth: z.string(),
    borderLeftWidth: z.string(),
    borderTopColor: z.string(),
    borderRightColor: z.string(),
    borderBottomColor: z.string(),
    borderLeftColor: z.string(),
    borderTopStyle: z.string(),
    borderRightStyle: z.string(),
    borderBottomStyle: z.string(),
    borderLeftStyle: z.string(),
    borderRadius: z.string(),
    // Other styles
    opacity: z.string(),
    width: z.string(),
    height: z.string(),
  })
  .describe("ComputedElementStyles");

export const tailwindTextClassesSchema = z
  .object({
    fontSize: z.string().optional(),
    fontWeight: z.string().optional(),
    fontStyle: z.string().optional(),
    lineHeight: z.string().optional(),
    letterSpacing: z.string().optional(),
    textAlign: z.string().optional(),
    textColor: z.string().optional(),
    textTransform: z.string().optional(),
    textDecoration: z.string().optional(),
    fontFamily: z.string().optional(),
    whitespace: z.string().optional(),
  })
  .describe("TailwindTextClasses");

export const boundingBoxSchema = z.object({
  x: z.number(),
  y: z.number(),
  width: z.number(),
  height: z.number(),
});

const eventHandlersSchema = z.object({
  onClick: z.string().optional(),
  onMouseEnter: z.string().optional(),
  onMouseLeave: z.string().optional(),
  onFocus: z.string().optional(),
  onBlur: z.string().optional(),
});

export const semanticElementSchema = z
  .object({
    elementType: z.string(),
    name: z.string(),
    path: z.string(),
    selector: z.string(),
    tagName: z.string(),
    cssClasses: z.string(),
    text: z.string().optional(),
    outerHtml: z.string(),
    sourceLocation: sourceLocationSchema.optional(),
    boundingBox: boundingBoxSchema,
    eventHandlers: eventHandlersSchema.optional(),
    computedStyles: computedElementStylesSchema.optional(),
    tailwindClasses: tailwindTextClassesSchema.optional(),
    nearbyText: z.string().optional(),
    nearbyElements: z.string().optional(),
    openingTag: z.string().optional(),
    hasChildren: z.boolean().optional(),
  })
  .describe("SemanticElement");
